import { render, staticRenderFns } from "./CustomerWizard.vue?vue&type=template&id=53d1e658"
import script from "./CustomerWizard.vue?vue&type=script&lang=js"
export * from "./CustomerWizard.vue?vue&type=script&lang=js"
import style0 from "./CustomerWizard.vue?vue&type=style&index=0&id=53d1e658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports